//사용자 리스트
import React, { Component } from "react";

import AgGridReactEx from "@app/components/AgGridReactEx";
import PaginationV2 from '@app/components/Pagination/V2';

import { ta } from "date-fns/locale";

const basePagingInfo = { perPage: 18, maxShowPage: 10 };

export default class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: null,
            tableData: null,
            keyword: null,
			page : this.props.page || 0,
			type : this.props.type || "user_id",
			total_cnt: this.props.total_cnt,
			row: this.props.row,
			onSelectPage: this.props.onSelectPage,
			onRowSelected: this.props.onRowSelected
        };
        this.searchRef = React.createRef();
    }

    componentDidMount = () => {
		if(this.props.data != null) {
			this.updateData(this.props);
		}
    };

    componentWillReceiveProps = (nextProps) => {
		this.updateData(nextProps);
	};

	updateData = (props) => {
        this.setState(
            {
                data: props.data,
				total_cnt: props.total_cnt,
				page: props.page,
				row: props.row,
				onSelectPage: props.onSelectPage
            },
            () => {
                this.setState({ tableData: this.listSearch(this.state.keyword)});
            }
        );
	};

    defaultColDef = {
        editable: false,
        sortable: true,
        minWidth: 40,
        filter: false,
        resizable: true,
        cellClass: "text-center",
        headerClass: "bg-dark text-light",
        suppressMovable: true,
    };

    listColumn = [
    	{
		    headerName: "No",
		    field: "rowIndex",
		    sortable: false,
		    width : 70,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
		},
		{
		    headerName: "원 명",
		    field: "nursery_uniq_name",
		    sortable: false,
		    maxWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "계정",
		    field: "user_id",
		    sortable: false,
		    minWidth : 80,
		    maxWidth : 140,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "타입",
		    field: "role",
		    sortable: false,
		    width : 70,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false
		},
		{
		    headerName: "반 명",
		    field: "class_name",
		    sortable: false,
		    minWidth : 80,
		    maxWidth : 180,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					return param.data.class_name;
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "계약 원아 수 ",
		    field: "quantity",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					return param.data.quantity;
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "딩동 원아 수 ",
		    field: "ddChildCount",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
		},
		{
		    headerName: "플라잉\n 원아 수",
		    field: "e_quantity",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					return param.data.e_quantity;
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "디바이스",
		    field: "device",
		    sortable: false,
		    width : 100,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.device === "board") {
						return "전자칠판";
					} else if(param.data.device === "tablet"){
						return "태블릿";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "결합상품",
		    sortable: false,
		    width : 100,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.unionInfo){
					return param.data.unionInfo.name;
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "토모노트",
		    field: "tomonote",
		    sortable: false,
		    width : 100,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.tomonote === "AP") {
						return param.data.age != "123" ? "만 "+(param.data.age+2)+"세" : "혼합";
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "플레이딩동",
		    field: "play_dd",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.playdd === "AP") {
						return param.data.age_playdd == 123 ? "혼합" : "만 "+(param.data.age_playdd+2)+"세" ;
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "모모한글수",
		    field: "momo",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.momo === "AP") {
						return param.data.age_momo == 123 ? "혼합" : "만 "+(param.data.age_momo+2)+"세" ;
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "젤링",
		    field: "jelliing",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.jelliing === "AP") {
						return param.data.age_jelliing == 123 ? "혼합" : "만 "+(param.data.age_jelliing+2)+"세" ;
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "별별책방",
		    field: "tomobooks",
		    sortable: false,
		    width : 100,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.tomobooks === "AP") {
						return param.data.age_books == 123 ? "혼합" : "만 "+(param.data.age_books+2)+"세" ;
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
		{
		    headerName: "플라잉",
		    field: "flyeng",
		    sortable: false,
		    width : 80,
		    resizable : true,
		    cellClass: "text-center",
		    filter: false,
			cellRenderer : (param) => {
				if(param.data.role === "T"){
					if (param.data.tomoenglish === "AP") {
						return param.data.age_english == 123 ? "혼합" : "만 "+(param.data.age_english+2)+"세";
					} else {
						return "미사용";
					} 
				} else {
					return "-";
				}
        	}
		},
	];

    handleKeyPress = (e) => {
        if (e.key === "Enter") {
            this.searchData();
        }
    };

    searchData = () => {
        if (this.searchRef.current) {
            var keyword = this.searchRef.current.value;

            var tableData = this.listSearch(keyword);

            this.setState({
                tableData: tableData,
                keyword: keyword,
            });
        }
    };

    listSearch = (keyword) => {
        var list = this.state.data;
        var tableData = [];
        if (!keyword) {
            tableData = list;
        } else {
            if (list && list.length > 0) {
                list.map((item) => {
                    if (item.nurseryName && item.nurseryName.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                    if (item.menu && item.menu.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                    if (item.category && item.category.indexOf(keyword) >= 0) {
                        tableData.push(item);
                    }
                });
            }
        }
        return tableData;
    };

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
    };

    rowClick = (agGrid) => {
        const selected = agGrid.api.selectionController.lastSelectedNode.data;
        if (selected && this.props.onRowClick) {
            this.props.onRowClick(selected.nurseryUniqId, selected.nurseryName);
        }
    };

    rowDataChanged = (parmas) => {
        this.setState({
            tableSummary: (this.state.tableData ? this.state.tableData.length.toLocaleString() : 0) + " / " + (this.state.data ? this.state.data.length.toLocaleString() : 0),
        });
    };

    onSortChanged = (params) => {
        const sortState = params.api.getSortModel();
        if (sortState.length == 0) {
            this.props.onListSortChanged(null, null);
        } else {
            if (this.props.onListSortChanged) {
                this.props.onListSortChanged(sortState[0].colId, sortState[0].sort);
            }
        }
    };
	

    render() {
        if (this.state.tableData == null) {
            return (
                <>
                    <div
                        style={{
                            height: this.props.height + "px",
                            textAlign: "center",
                            paddingTop: `${this.props.height / 2 - 80}px`,
                        }}
                    >
                        <span className="dashboard-spinner spinner-xxl"></span>
                    </div>
                </>
            );
        } else {
            return (
                <>
                    
                    <div className="row">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                             <AgGridReactEx
                                defaultColDef={this.defaultColDef}
                                columnDefs={this.listColumn}
                                rowData={this.state.tableData}
                                onGridReady={this.onGridReady}
                                onRowDataChanged={this.rowDataChanged}
                                onSortChanged={this.onSortChanged}
                                rowSelection="single"
                                onSelectionChanged={this.rowClick}
								onRowClicked={(e) => {
									this.state.onRowSelected(e);
								}}
                            /> 
                        </div>
                    </div>
					<div className="row" style={{marginTop : "10px"}}>
						<div className="col-xl-5 col-lg-5 col-md-5 col-sm-5 col-5" style={{float: 'right'}}>
                    		<PaginationV2 perPage={this.state.row} maxShowPage={basePagingInfo.maxShowPage} currentPage={Number(this.state.page)} total={this.state.total_cnt} callback={this.state.onSelectPage}/>
						</div>
						
					</div>
                </>
            );
        }
    }
}
